import { useEffect, useState } from 'react';
import { FlowyProject } from '../../flowy';
import { IFlowyProject, IFlowyRoute } from '../../types';

interface IUseFlowyProject {
  config: IFlowyProject;
}

/**
 * Custom hook that will be used by the FlowyProject react component in order to access
 * the project's functionality and data
 *
 * @param {IFlowyProject} config project's configuration
 *
 * @returns custom hook
 */
const useFlowyProject = ({ config }: IUseFlowyProject) => {
  const [flowyProject, setFlowyProject] = useState<FlowyProject | undefined>();
  const [flowyRoutes, setFlowyRoutes] = useState<IFlowyRoute[]>([]);

  useEffect(() => {
    const f = new FlowyProject({ config, basePath: '', path: '/' });
    f.init().then((fp: FlowyProject) => {
      setFlowyProject(fp);
      setFlowyRoutes(fp.getFlowyRoutes());
    });
  }, []);

  return {
    flowyProject,
    flowyRoutes,
  };
};

export default useFlowyProject;
